import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import {
	defaultsToArticleOption,
	getOffset,
	getPrice,
	getSlotsByOrder,
	isDeliveryVenueOpen,
	isVenueOpen,
	numberToCurrency,
} from '../../../smoothr-web-app-core/utils/utils';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalController } from '@ionic/angular';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { TosPage } from '../../pages/tos/tos.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { calculateGeoDistance, MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { TimeUtils } from '../../../smoothr-web-app-core/utils/time-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { environment } from 'src/environments/environment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { AvailableDriverModalComponent } from '../available-driver-modal/available-driver-modal.component';
import { countries } from '../input-phone-with-county-code/mock-countries';
import { OrderListAction } from 'src/app/enums/OrderListAction';
import { BrazeService } from '../../services/braze.service';
import Offset from '../../../smoothr-web-app-core/models/Offset';
import { Company } from 'src/smoothr-web-app-core/models/CompanyCode';

@Component({
	selector: 'app-checkout-modal',
	templateUrl: './checkout-modal.component.html',
	styleUrls: ['checkout-modal.component.scss'],
})
export class CheckoutModalComponent extends RepositoryDirective implements OnInit, AfterViewInit {
	@ViewChild('swiperCheckout', { static: false }) slides;
	@Output() closedDialog = new EventEmitter<void>();

	orderUtils = OrderUtils;
	loading = false;
	loadingSlots = false;
	now: moment.Moment;
	pt = PreorderType;
	nameError: string;
	emailError: string;
	phoneError: string;
	streetNumberError: string;
	orderAtError: string;
	streetError: string;
	postalCodeError: string;
	hadPostalCode = false;
	telCountryOptions: any = {
		cssClass: 'tel-country-popover',
	};
	isVenueOpen = false;
	tip: number = 0;
	ou = OrderUtils;
	orderForm: FormGroup;
	checkoutForm: FormGroup;
	firstName = 'firstName';
	lastName = 'lastName';
	email = 'email';
	phone = 'phone';
	note = 'note';
	orderAt = 'orderAt';

	numberToCurrency = numberToCurrency;
	slots: Moment[] = [];
	environment = environment;
	uberQoateExist: boolean = false;
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	isOverviewPage = false;
	street = 'street';
	city = 'city';
	postalCode = 'postalCode';
	number = 'number';
	totalPriceValue: string = '';
	companyDiscount = '';
	totalPriceBeforeDiscount = '';
	mappedOrderArticlesValue: ArticleGroup[] = [];
	loadQuote: boolean = false;
	paperBag: Article = null;
	paperBagGroup: ArticleGroup = null;
	offset: Offset;
	hasExplicitOrderAtSelection = false;

	constructor(
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private translate: TranslateService,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder,
		private brazeService: BrazeService,
		private destroyRef: DestroyRef
	) {
		super(repository);
		if (this.address && this.address.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
		if (this.order && this.order.preorder && this.order.preorder.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
	}

	// ngAfterViewInit(): void {
	// 	this.toOverview(); //TODO: to remove;
	// }

	static async show(modalCtrl: ModalController, analytics: AnalyticsService, order: Order, tip: number) {
		const openTime = Date.now();
		const modal = await modalCtrl.create({
			component: CheckoutModalComponent,
			componentProps: {
				tip,
				openTime,
			},
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'menu-modal',
		});
		await modal.present();
		analytics.beginCheckout(order);
		return await modal.onDidDismiss();
	}

	openTime: number;

	ngOnInit() {
		super.ngOnInit();
		this.analytics.screenLoadTime('checkout_details', Date.now() - (this.openTime ?? Date.now()));
		this.analytics.checkoutProgress(this.order, null, 1);
		this.analytics.customerBeginsCheckout(this.order);
		this.createOrderForm();
		this.createCheckoutForm();
		this.repository.companyCode$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
				this.totalPrice();
			}
		});

		this.checkPrevOrder();
		this.totalPrice();
		this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
			it = this.mapGroup(it);
			return it;
		});
		this.orderForm.get('orderAt').valueChanges.subscribe(v => {
			if (
				this.venue?.deliveryProviders?.uberDirect?.enabled &&
				(this.venue?.deliveryProviders?.uberDirect?.deliverableOrderTypes ?? []).find(it => it === this.order.preorder.type)
			) {
				this.uberQoateExist = false;
			}
		});

		this.getPaperBag();
	}

	ngAfterViewInit() {
		this.loadSlots();
	}

	onOrder() {
		super.onOrder();
		const postalCodeInOrder =
			this.order && this.order.preorder && this.order.preorder.postalCode && this.order.preorder.postalCode.length > 0;
		this.cdr.detectChanges();
		this.totalPrice();
	}

	checkPrevOrder() {
		if (this.order && this.order.preorder) {
			if (this.repository._previousPreorder) {
				const prevName = this.repository._previousPreorder?.name ?? '';
				const prevParts = prevName.trim().split(' ');
				this.orderForm.patchValue({
					firstName: prevParts[0] ?? '',
					lastName: prevParts.slice(1).join(' ') ?? '',
					email: this.repository._previousPreorder?.email ?? '',
				});
			}
			if (this.repository._previousPreorder?.phone) {
				let defaultPhone = {
					country: '+49',
					phone: '',
				};

				if (this.repository && this.repository._previousPreorder?.phone) {
					let countryCode = countries.find(it => this.repository._previousPreorder?.phone?.trim().startsWith('+' + it.dialCode));
					defaultPhone = {
						country: '+' + countryCode?.dialCode ?? '+49',
						phone: this.repository._previousPreorder?.phone
							? this.repository._previousPreorder?.phone?.trim()?.replace('+' + countryCode?.dialCode, '')
							: '',
					};

					this.orderForm.patchValue({
						phone: {
							country: defaultPhone.country,
							phone: defaultPhone.phone,
						},
					});
				}
			}
		}
	}

	onAddress() {
		super.onAddress();
		this.hadPostalCode = this.hadPostalCode || (this.address && this.address.postalCode && this.address.postalCode.length > 0);
	}

	onCustomer() {
		super.onCustomer();
	}

	checkCustomer() {
		if (this.customer) {
			if (this.customer?.firstName || this.customer?.lastName || this.customer?.name) {
				this.orderForm.patchValue({
					firstName: this.customer.firstName || this.customer.name?.split(' ')?.[0] || '',
					lastName: this.customer.lastName || this.customer.name?.split(' ')?.slice(1)?.join(' ') || '',
				});
			}
			if (this.customer?.email) {
				this.orderForm.patchValue({
					email: this.customer?.email,
				});
			}
			if (this.customer?.phone) {
				let defaultPhone = {
					country: '+49',
					phone: '',
				};

				if (this.repository && this.customer?.phone && this.customer?.phone) {
					let countryCode = countries.find(it => this.customer?.phone.trim().startsWith('+' + it.dialCode));
					defaultPhone = {
						country: '+' + countryCode?.dialCode ?? '+49',
						phone: this.customer?.phone ? this.customer?.phone?.trim()?.replace('+' + countryCode?.dialCode, '') : '',
					};

					this.orderForm.patchValue({
						phone: {
							country: defaultPhone.country,
							phone: defaultPhone.phone,
						},
					});
				}
			}
		}
	}

	async close() {
		await this.updateForm();

		let orderAt = this.order.orderAt?.toISOString();

		if (this.order.asap && isVenueOpen(this.venue)) {
			//adding orderAt if asap true
			const preparationTime =
				this.order.preorder.type === PreorderType.DELIVERY
					? this.venue.slot.readyOffsetDelivery
					: this.venue.slot.readyOffset || this.offset.offset;
			orderAt = moment()
				.utc(false)
				.add(preparationTime + 1, 'minutes')
				.toISOString();
		}

		const data = {
			preorder: this.order.preorder,
			orderAt,
			tip: this.tip,
			asap: this.order.asap,
		};
		this.repository.previousPreorder.emit(this.order.preorder);

		await this.modalCtrl.dismiss(data);
	}

	async updateForm() {
		this.order.preorder.name = [this.getFormControlValue('firstName'), this.getFormControlValue('lastName')].filter(Boolean).join(' ');
		if (this.getFormControlValue('phone')?.phone && this.getFormControlValue('phone')?.country)
			this.order.preorder.phone = this.getFormControlValue('phone')?.country + this.getFormControlValue('phone')?.phone;
		this.order.preorder.email = this.getFormControlValue('email');
		this.order.preorder.note = this.getFormControlValue('note');

		const selectedOrderAt = this.normalizeOrderAt(this.getFormControlValue('orderAt'));
		if (selectedOrderAt) {
			this.order.orderAt = selectedOrderAt;
			this.order.asap = false;

			if (
				selectedOrderAt?.toISOString() === this.slots[0]?.toISOString() &&
				!this.isVenueOpen &&
				this.slots[0].isBefore(moment().add(this.offset.offset, 'minutes'))
			) {
				//hack for the case when the user wants to use a slot with offset.first when the venue is closed
				this.order.asap = true;
			}
		} else {
			this.order.orderAt = null;
			this.order.asap = true;
		}
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			this.order.preorder.city = this.getFormControlValue('city');
			this.order.preorder.postalCode = this.getFormControlValue('postalCode');
			this.order.preorder.number = this.getFormControlValue('number');
			this.order.preorder.street = this.getFormControlValue('street');
		}
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			const company = this.repository.companyCode$.getValue();
			this.order.preorder.city = company?.deliveryAddress?.city ?? '';
			this.order.preorder.postalCode = company?.deliveryAddress?.postalCode ?? '';
			this.order.preorder.number = company?.deliveryAddress?.number ?? '';
			this.order.preorder.street = company?.deliveryAddress?.street ?? '';
		}
		this.repository.onOrderChange(this.order);

		const body = {
			...this.repository.customer,
		};
		const hadMailingSubscription = !!(
			this.repository.customer?.subscribedToMailing ||
			this.repository.customer?.singleOptIn ||
			this.repository.customer?.doubleOptIn
		);
		const isSubscribingToMailing = this.checkoutForm.get('emailSubs').value === true;
		if (isSubscribingToMailing) {
			body.subscribedToMailing = true;
			if (!hadMailingSubscription) {
				body.subscribedToMailingSource = 'app_checkout';
				body.subscribedToMailingAt = new Date().toISOString();
			}
		} else {
			delete body.subscribedToMailing;
		}

		if (this.repository.customer.isAnonymous) {
			body.email = this.getFormControlValue('email');
			body.firstName = this.getFormControlValue('firstName');
			body.lastName = this.getFormControlValue('lastName');
			body.name = [body.firstName, body.lastName].filter(Boolean).join(' ');
		}

		Api.patchCustomer(body)
			.then(res => {
				const mainUser = this.repository._customerAuth;
				mainUser.customer = {
					...mainUser.customer,
					...res.data,
					...(body.subscribedToMailing !== undefined
						? {
								subscribedToMailing: body.subscribedToMailing,
								singleOptIn: body.subscribedToMailing,
								subscribedToMailingSource: body.subscribedToMailingSource,
								subscribedToMailingAt: body.subscribedToMailingAt,
							}
						: {}),
				};
				this.repository.customerAuth.emit(mainUser);
			})
			.catch(err => {
				console.error(err);
				this.loading = false;
			});
	}

	async dismiss() {
		await this.modalCtrl.dismiss();
	}

	async openTos() {
		window.open(TosPage.url, '_blank');
	}

	async openPrivacy() {
		window.open(PrivacyPage.url, '_blank');
	}

	slotToText(slot: Moment): string {
		const asapPossible = (OrderUtils.isInside(this.order) || OrderUtils.isTakeAway(this.order)) && this.isVenueOpen;
		if (!slot) {
			return this.translate.instant(asapPossible ? 'checkout_modal.first_slot' : 'checkout_modal.choose_slot');
		}
		const slotMoment = moment(slot);
		const sameDay = TimeUtils.isSameDate(slotMoment, moment());
		if (sameDay) {
			return slotMoment.format('HH:mm');
		} else {
			return slotMoment.format('DD.MM. HH:mm');
		}
	}

	onVenue() {
		this.isVenueOpen = isVenueOpen(this.venue);
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.isVenueOpen = false;
		if (this.order) {
			this.order.asap = false;
		}
	}

	async submitFormCustomValidator() {
		let controlStreetValue = this.getFormControlValue('street').trim();
		let controlHouseNumberValue = this.getFormControlValue('number').trim();
		let controlPostalCodeValue = this.getFormControlValue('postalCode').trim();
		let controlCityValue = this.getFormControlValue('city').trim();
		if (
			OrderUtils.isDelivery(this.order) &&
			(controlStreetValue !== this.address.street ||
				controlPostalCodeValue !== this.address.postalCode ||
				controlCityValue !== this.address.city ||
				controlHouseNumberValue !== this.address.number)
		) {
			try {
				const pred = controlStreetValue + ' ' + controlHouseNumberValue + ', ' + controlCityValue + ' ' + controlPostalCodeValue;
				const geocode = await MapsUtils.getPlace(pred);
				const address = MapsUtils.placeToAddress(geocode);
				const addressValidationResult = ValidationUtils.validateAddress(address, true);
				if (addressValidationResult) {
					// this.streetError = this.translate.instant(addressValidationResult);
					this.orderForm.controls['street'].setErrors({ incorrect: true });
					return false;
				}
				const delivers =
					(this.venue.deliveryByRadius &&
						calculateGeoDistance(
							address.lat,
							address.lng,
							this.venue.location.coordinates[1],
							this.venue.location.coordinates[0]
						) <= this.venue.deliveryRadius) ||
					(this.venue.isPostalDelivery && this.venue.deliveryPostalCodes.indexOf(address.postalCode));
				if (!delivers) {
					this.orderForm.controls['street'].setErrors({ street_delivery: true });

					this.snackbarCtrl.open(this.translate.instant('errors.street_delivery'), null, {
						duration: 2000,
					});
					return false;
				}
				this.repository.address.emit(address);
				this.orderForm.patchValue({
					street: this.address.street,
				});
				return true;
			} catch (e) {
				this.orderForm.controls['street'].setErrors({ street_not_found: true });
				this.snackbarCtrl.open(this.translate.instant('errors.street_not_found'), null, {
					duration: 2000,
				});
				return false;
			}
		} else {
			return true;
		}
	}

	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}

	reloadAddress() {
		if (this.order && this.order.preorder && this.address && this.order.preorder.type === PreorderType.DELIVERY && this.orderForm) {
			this.orderForm.patchValue({
				city: this.address?.city ?? '',
				street: this.address?.street ?? '',
				postalCode: this.address?.postalCode && this.address?.postalCode?.length > 0 ? this.address.postalCode : '',
				country: this.address?.country,
				number: this.address?.number,
			});
		}
	}

	async onButtonClick() {
		if (!this.isFormValid()) {
			return;
		}

		//remove Paper Bag with zero quantity
		const zeroOrderArtticle = this.order.orderedArticles.find(
			article => article.quantity === 0 && article.article?.tags?.find(tag => tag.identifier === 'bag')
		);
		if (zeroOrderArtticle) {
			await this.onAction(zeroOrderArtticle, OrderListAction.delete);
		}

		if (this.isFormValid)
			if (this.order?.preorder?.type === PreorderType.DELIVERY) {
				if (!(await this.submitFormCustomValidator())) {
					return;
				}
			}

		if (!this.isOverviewPage) {
			await this.toOverview();
		} else {
			await this.close();
		}
	}

	async toOverview() {
		// await this.slides.update();
		await this.slides.nativeElement.swiper.slideNext();
		this.isOverviewPage = true;
		this.cdr.detectChanges();
	}

	async editPersonalData() {
		await this.slides.nativeElement.swiper.slidePrev();
		this.isOverviewPage = false;
		this.cdr.detectChanges();
	}

	slotSelected($event) {
		this.order.orderAt = this.normalizeOrderAt($event);
		if (!this.order.orderAt) {
			this.order.asap = true;
		} else {
			this.order.asap = false;
		}
	}

	async backOrDismiss() {
		if (this.isOverviewPage) {
			await this.editPersonalData();
		} else {
			await this.dismiss();
		}
	}

	async loadSlots() {
		this.slots = [];
		this.order.orderAt = null;
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000,
			});
			return;
		}
		// if (this.loading) {
		// 	return;
		// }
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			this.slots = [];
			this.order.orderAt = null;
			this.order.asap = true;
			return;
		}
		this.loading = true;

		try {
			//TODO: not touch while TUR testing

			this.loadingSlots = true;
			const allSlots = await getSlotsByOrder(this.venue, this.order);
			const slots = [...new Set(allSlots.map(item => moment(item.time).format('X')))].map(it => moment.unix(Number(it)));
			this.offset = getOffset(this.venue, this.order.type, this.order.preorder.type, null, null);
			if (slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
			if (this.order.preorder.type != PreorderType.DELIVERY) {
				const resultOfStart = TimeUtils.doesHoursMatchOffsets(moment(), this.venue.openingHours, 0);

				let isVenueOpenVar = true;
				try {
					isVenueOpenVar = isVenueOpen(this.venue);
				} catch (e) {}
				if (slots.length > 0) {
					if (isVenueOpenVar && resultOfStart) {
						this.slots = [null, ...slots];
					} else {
						this.slots = [...slots];
					}
				}
			} else {
				const resultOfStart = TimeUtils.doesHoursMatchOffsets(moment(), this.venue.deliveryHours, 0);

				let isVenueDeliveryOpenVar = true;
				try {
					isVenueDeliveryOpenVar = isDeliveryVenueOpen(this.venue);
				} catch (e) {}
				if (slots.length > 0) {
					if (isVenueDeliveryOpenVar && resultOfStart) {
						this.slots = [null, ...slots];
					} else {
						this.slots = [...slots];
					}
				}
			}

			if (
				this.order.preorder.type == PreorderType.DELIVERY &&
				this?.venue?.deliveryProviders?.uberDirect?.enabled &&
				(this.venue?.deliveryProviders?.uberDirect?.deliverableOrderTypes ?? []).find(it => it === this.order.preorder.type)
			) {
				this.slots = this.slots.filter(it => !!it);
				const cutedFirstSlots = this.slots.slice(0, 3);
				const checkAvaibility = await Promise.all(
					cutedFirstSlots.map((it, index) => {
						return this.checkSlotQuate(it, true);
					})
				);
				this.slots = this.slots.filter(it => {
					const findTime = checkAvaibility.find(result => result.value.isSame(it));
					if (findTime) {
						return findTime.result;
					} else {
						return true;
					}
				});
			}

			if (this.slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
			this.loadingSlots = false;
		} catch (e) {
			this.loadingSlots = false;
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000,
			});
			console.error(e);
		}
		this.loading = false;
	}

	onOrderAtSelectionChange(hasSelection: boolean) {
		this.hasExplicitOrderAtSelection = hasSelection;
		if (hasSelection) {
			this.orderAtError = null;
		}
	}

	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		if (articleGroup) {
			const findGroup = articleGroup.article.groups.find(it => it._id === articleOption.group);
			if (findGroup) {
				if (findGroup.tags.find(it => it.identifier === 'half_pizza')) {
					return 0;
				}
			}
		}
		return price * articleOption.quantity;
	}

	createOrderForm() {
		const formControlNames: any = {};
		const initialOrderAt = this.normalizeOrderAt(this.order?.orderAt);
		this.order.orderAt = initialOrderAt;
		this.hasExplicitOrderAtSelection = !!initialOrderAt;

		formControlNames[this.firstName] = ['', [Validators.required, Validators.pattern(/^[^0-9]*$/)]];
		formControlNames[this.lastName] = ['', [Validators.required, Validators.pattern(/^[^0-9]*$/)]];

		formControlNames[this.email] = [
			'',
			[
				Validators.required,
				Validators.pattern(
					"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
				),
			],
		];

		formControlNames[this.phone] = [
			'',
			[Validators.required, this._customPhoneValidatorForLibrary, this._customPhoneValidatorForGermany],
		];

		formControlNames[this.note] = ['', []];

		formControlNames[this.orderAt] = [initialOrderAt];
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			formControlNames[this.street] = ['', [Validators.required]];
			formControlNames[this.city] = ['', [Validators.required]];
			formControlNames[this.postalCode] = ['', [Validators.required]];
			formControlNames[this.number] = ['', [Validators.required]];
		}
		this.orderForm = this.fb.group(formControlNames);
		this.checkCustomer();
		this.reloadAddress();
	}

	createCheckoutForm() {
		this.checkoutForm = this.fb.group({
			emailSubs: new FormControl(false),
		});
	}

	_customPhoneValidatorForGermany(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}

		const phoneNumber = control.value.country + control.value.phone.toString();

		if (phoneNumber.startsWith('00')) {
			return { invalidPhone: 'Invalid format: use "+" instead of "00"' };
		}

		if (phoneNumber.startsWith('+490') || phoneNumber.startsWith('+430')) {
			return { invalidPhone: 'Phone number should not start with +490' };
		}
		const digitOnlyRegex = /^\+49\d+$/;
		const digitOnlyRegex2 = /^\+43\d+$/;
		if (phoneNumber.startsWith('+49')) {
			if (!digitOnlyRegex.test(phoneNumber)) {
				return { invalidPhone: 'Phone number must contain digits only.' };
			}
		}
		if (phoneNumber.startsWith('+43')) {
			if (!digitOnlyRegex2.test(phoneNumber)) {
				return { invalidPhone: 'Phone number must contain digits only.' };
			}
		}
		if (phoneNumber.length > 15) {
			return { invalidPhone: 'Phone number cannot exceed 15 digits.' };
		}

		if (phoneNumber.length < 12) {
			return { invalidPhone: 'Phone number must have at least 9 digits after +49.' };
		}

		return null;
	}

	private _e164PhoneNumberValidator(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		const phoneNumberRegex = /^\+[1-9]\d{1,14}$/;
		const phoneNumber = control?.value?.country + control?.value?.phone.toString();
		// return (control: AbstractControl): ValidationErrors | null => {
		//   if (!control.value) return null; // Don't validate empty values

		const valid = phoneNumberRegex.test(phoneNumber);
		return valid ? null : { invalidPhone: true };
		// };
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		try {
			const phoneNumber = parsePhoneNumberFromString(control?.value?.country + control?.value?.phone.toString());
			if (phoneNumber.isValid() && phoneNumber.isPossible()) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	getFormControlValue(controlName?: string) {
		if (controlName) {
			if (controlName === this.orderAt) {
				return this.normalizeOrderAt(this.orderForm.get(controlName)?.value);
			}
			return this.orderForm.get(controlName)?.value;
		}
		return '';
	}

	private normalizeOrderAt(value: any): Moment | null {
		if (value === null || value === undefined || value === '') {
			return null;
		}
		const normalized = moment.isMoment(value) ? value.clone() : moment(value);
		return normalized.isValid() ? normalized : null;
	}

	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.hasError('required') && this.orderForm?.get(controlName)?.touched;
		}
		return this.orderForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.errors && !this.orderForm?.get(controlName)?.hasError('required');
		}
		return this.orderForm.invalid;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.orderForm.get(controlName).errors;
		}

		return null;
	}

	private _customPhoneValidator(control: AbstractControl) {
		try {
			const phoneNumber = parsePhoneNumberFromString(control?.value);
			if (phoneNumber.isValid() && phoneNumber.isPossible()) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {}

	totalPrice() {
		this.totalPriceValue = numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null) + this.tip,
			this.order.currency
		);
		this.totalPriceBeforeDiscount = numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, false, false) + this.tip,
			this.order.currency
		);
		const code = this.repository.companyCode$.getValue();
		this.companyDiscount =
			this.order.preorder.type === PreorderType.FOOD_SPOT && code?.storeDiscount
				? (Number(code.storeDiscount) * 100).toString() + '%'
				: '';
		// if (this.venue) {
		// 	const foundArticleIndex = this.order.orderedArticles.findIndex(it => it.isHalfPizza);
		// 	if (foundArticleIndex >= 0) {
		// 		console.log('here before calc');
		// 		const foundArticle = this.venue.articleCategories
		// 			.map(it => it.articles.find(ar => ar.tags.find(tag => tag.identifier == 'appliesMostExpensive')))
		// 			.filter(it => !!it);
		// 		console.log(foundArticle);
		// 		if (foundArticle.length > 0) {
		// 			let mappedOrder = JSON.parse(JSON.stringify(this.order));
		// 			mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
		// 				if (it.isHalfPizza) {
		// 					it.article = foundArticle[0];
		// 				}
		// 				return it;
		// 			});
		// 			// mappedOrder.orderedArticles[foundArticleIndex].article = foundArticle[0];
		// 			this.totalPriceValue = numberToCurrency(
		// 				OrderUtils.orderTotalPrice(mappedOrder, true, true) + this.tip,
		// 				this.order.currency
		// 			);
		// 			return;
		// 		}
		// 	}
		// } else {
		// 	this.totalPriceValue = numberToCurrency(OrderUtils.orderTotalPrice(this.order, true, true) + this.tip, this.order.currency);
		// }
	}

	get activeFoodspotCompanyCode(): Company | null {
		if (this.order?.preorder?.type !== PreorderType.FOOD_SPOT) {
			return null;
		}
		return this.repository.companyCode$.getValue() ?? null;
	}

	changeTip(tip: number) {
		this.tip = tip;
		this.totalPrice();
	}

	checkPriceArticle(articleGroup: ArticleGroup, orderType: OrderType, preorderType: PreorderType) {}

	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (this.venue) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));

				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}

	async checkSlotQuate(time: Moment, error = false) {
		try {
			const result = await this.validateOfSpecifirSlotsForDeliveryWithUber(time.toString(), error);
			return { value: time, result };
		} catch (e) {
			return { value: time, result: null };
		}
	}

	async validateOfSpecifirSlotsForDeliveryWithUber(time: string, isHaveError: Boolean = false) {
		const venueAdress = {
			street: this.venue.street,
			number: this.venue.number,
			postalCode: this.venue.postalCode,
			city: this.venue.city.de,
			country: this.venue.country,
			lng: this.venue.location.coordinates[0],
			lat: this.venue.location.coordinates[1],
			state: this.venue.state,
		};
		const params = {
			pickup_address: MapsUtils.addressToString(venueAdress),
			dropoff_address: MapsUtils.addressToString(this.address),
			pickup_latitude: this.venue.location.coordinates[1],
			pickup_longitude: this.venue.location.coordinates[0],
			dropoff_latitude: this.address.lat,
			dropoff_longitude: this.address.lng,
			pickup_ready_dt: new Date(new Date(time).getTime() - (this.venue.offsets.preorder.delivery.first + 10) * 60000).toISOString(),
			pickup_deadline_dt: new Date(time).toISOString(),
			dropoff_ready_dt: new Date(time).toISOString(),
			dropoff_deadline_dt: new Date(new Date(time).getTime() + 20 * 60000).toISOString(),
			pickup_phone_number: this.venue.phoneNumber,
			dropoff_phone_number: this.getFormControlValue('phone')?.internationalNumber,
			manifest_total_value: Math.round(this.orderUtils.orderTotalPrice(this.order, true, true) + this.tip),
			external_store_id: '',
		};

		try {
			if (
				isHaveError &&
				!this.venue?.deliveryProviders?.uberDirect?.enabled &&
				(this.venue?.deliveryProviders?.uberDirect?.deliverableOrderTypes ?? []).find(it => it === this.order.preorder.type)
			) {
				return null;
			}
			return await Api.checkQoate(params, this.venue.uberCustomerId);
		} catch (e) {
			if (!isHaveError) {
				this.snackbarCtrl.open('Driver is not available at this time slot, try another one...', null, {
					duration: 4000,
				});
			}

			return null;
		}
	}

	async selectTimeSlot(time: string | Moment) {
		try {
			this.loadQuote = true;
			const selectedTime = this.normalizeOrderAt(time);
			if (!selectedTime) {
				this.loadQuote = false;
				return;
			}

			const result = await this.validateOfSpecifirSlotsForDeliveryWithUber(selectedTime.toISOString());
			this.loadQuote = false;
			if (result) {
				this.uberQoateExist = true;
				await AvailableDriverModalComponent.show(this.modalCtrl);
				return;
			}
			this.slots = this.slots.filter(it => !it.isSame(selectedTime));
			this.snackbarCtrl.open('Sorry on this time drivers is not avaible....', null, {
				duration: 4000,
			});
		} catch (e: any) {
			this.loadQuote = false;
		}
	}

	isFormValid() {
		const hasPhone = !!this.orderForm?.get('phone')?.value?.phone;
		const hasValidScheduleSelection = this.order.preorder.type === PreorderType.FOOD_SPOT || this.hasExplicitOrderAtSelection;
		if (
			this.order.preorder.type === PreorderType.DELIVERY &&
			this.venue?.deliveryProviders?.uberDirect?.enabled &&
			(this.venue?.deliveryProviders?.uberDirect?.deliverableOrderTypes ?? []).find(it => it === this.order.preorder.type)
		) {
			return !!(this.orderForm?.valid && hasValidScheduleSelection && this.uberQoateExist && hasPhone);
		}

		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			return !!(this.orderForm?.valid && hasPhone);
		}

		return !!(this.orderForm?.valid && hasValidScheduleSelection && hasPhone);
	}

	public checkDelivery() {
		return (
			this.venue?.deliveryProviders?.uberDirect?.enabled &&
			(this.venue?.deliveryProviders?.uberDirect?.deliverableOrderTypes ?? []).find(it => it === this.order.preorder.type)
		);
	}

	private findPaperBag(): Article {
		let paperBagArticle: Article;
		for (const cat of this.venue.articleCategories) {
			paperBagArticle = cat.articles.find(art => {
				return art.tags.some(tag => tag.identifier === 'bag') && art.visible && art.isActive;
			});
			if (paperBagArticle) {
				break;
			}
		}
		return paperBagArticle;
	}

	/*Add Paper Bag Logic */
	public getPaperBag() {
		const paperBagArticle: Article = this.findPaperBag();
		if (!paperBagArticle) {
			this.paperBag = null;
			this.paperBagGroup = null;
			return;
		}
		const paperBagInOrder = this.order.orderedArticles.find(it => it.article._id === paperBagArticle._id);

		this.paperBag = paperBagArticle;
		if (paperBagInOrder) {
			this.paperBagGroup = paperBagInOrder;
			return;
		}
		const paperBagGroup = new ArticleGroup();

		paperBagGroup.article = paperBagArticle;
		paperBagGroup.quantity = 0;
		paperBagGroup.categoryName = null;
		paperBagGroup.groups = defaultsToArticleOption(
			this.paperBag,
			[],
			this.paperBag?.defaults || [],
			this.order?.type,
			this.order?.preorder?.type
		);
		this.paperBagGroup = paperBagGroup;
	}

	async onAction(currentArticle: ArticleGroup, event: OrderListAction) {
		let index = this.order.orderedArticles.findIndex(
			(articleGroup: ArticleGroup) => articleGroup.article._id === currentArticle.article._id
		);
		switch (event) {
			case OrderListAction.add:
				this.paperBagGroup.quantity += 1;
				if (index >= 0) {
					this.order.orderedArticles[index] = this.paperBagGroup;
				} else {
					this.paperBagGroup.quantity = 1;
					OrderUtils.addToOrder(this.order, this.paperBagGroup, this.analytics);
				}

				break;
			case OrderListAction.delete:
				if (index < 0) {
					break;
				}
				this.order.orderedArticles.splice(index, 1);
				this.paperBagGroup.quantity = 0;
				break;
			case OrderListAction.edit:
			case OrderListAction.note:
				break;
			case OrderListAction.remove:
				if (this.paperBagGroup.quantity > 0) {
					this.paperBagGroup.quantity -= 1;
				}
				if (index >= 0) {
					this.order.orderedArticles[index] = this.paperBagGroup;
					if (this.paperBagGroup.quantity === 0) {
						this.order.orderedArticles.splice(index, 1);
					}
				}
				break;
		}
		this.repository.onOrderChange(this.order);
	}

	// async noteArticle(index: number) {
	// 	const modal = await this.modalCtrl.create({
	// 		cssClass: 'short-info-modal auto-height',
	// 		component: NoteArticleModalComponent,
	// 		componentProps: {
	// 			// copy article group
	// 			articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
	// 			recommend: false,
	// 		},
	// 		showBackdrop: true,
	// 		backdropDismiss: true,
	// 	});
	// 	await modal.present();
	// 	const response = await modal.onDidDismiss();
	// 	if (response?.data || response.data === '') {
	// 		this.order.orderedArticles[index].note = response?.data;
	// 	}
	// }
	protected readonly FormControl = FormControl;
}
